import { registerAction } from '../../Action'

const MARK_APPROVAL_COMPLETE = 'MARK_APPROVAL_COMPLETE'

const reducer = (state = {}, action) => {
  const approvableId = Number(action.payload.id)

  const approvals = Object.keys(state.approvals || {}).reduce((acc, curr) => {
    const currentBucket = [].concat(state.approvals[curr])
    const approvalToUpdate = currentBucket.find(
      (a) => Number(a.content.id) === approvableId
    )
    if (approvalToUpdate) {
      const idx = currentBucket.indexOf(approvalToUpdate)
      approvalToUpdate.recentlyCompleted = true
      currentBucket[idx] = approvalToUpdate
    }
    acc[curr] = currentBucket
    return acc
  }, {})

  return {
    ...state,
    approvals,
  }
}

const markApprovalComplete = registerAction(MARK_APPROVAL_COMPLETE, { reducer })

export default markApprovalComplete
